var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * WarningDiamondFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconWarningDiamondFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.72255 13.7444C0.75915 12.781 0.75915 11.219 1.72255 10.2556L10.2556 1.72255C11.219 0.759149 12.781 0.759151 13.7444 1.72255L22.2775 10.2556C23.2408 11.219 23.2408 12.781 22.2775 13.7444L13.7444 22.2774C12.781 23.2409 11.219 23.2409 10.2556 22.2774L1.72255 13.7444ZM12.0007 5.91184C12.6516 5.91184 13.1792 6.43947 13.1792 7.09031V12.197C13.1792 12.8479 12.6516 13.3755 12.0007 13.3755C11.3499 13.3755 10.8222 12.8479 10.8222 12.197V7.09031C10.8222 6.43947 11.3499 5.91184 12.0007 5.91184ZM13.572 16.5181C13.572 17.3859 12.8685 18.0894 12.0007 18.0894C11.1329 18.0894 10.4294 17.3859 10.4294 16.5181C10.4294 15.6503 11.1329 14.9468 12.0007 14.9468C12.8685 14.9468 13.572 15.6503 13.572 16.5181Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconWarningDiamondFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningDiamondFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningDiamondFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-warning-diamond-filled') === undefined) {
    customElements.define('cat-icon-warning-diamond-filled', BlocksIconWarningDiamondFilled);
}
